import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, TOKEN } from "../constants";

const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const hasContentType =
    config?.headers?.["Content-Type"] || config?.headers?.["content-type"];

  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${TOKEN}`,
    ...(hasContentType
      ? {}
      : {
        "Content-Type": "application/json",
      }),
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
    "Access-Control-Allow-Headers":
      "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
  };
  return config;
});

// Global error handling for Engin creation/update
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 400 && url.includes("/api/engin")) {
      const backendMessage = error?.response?.data?.error;
      if (backendMessage) {
        try {
          toast.error(backendMessage);
        } catch (e) {
          // noop if toast is unavailable in some contexts
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
